import { render } from "./RecordInfo.vue?vue&type=template&id=6e6eae5f"
import script from "./RecordInfo.vue?vue&type=script&lang=js"
export * from "./RecordInfo.vue?vue&type=script&lang=js"

import "./RecordInfo.vue?vue&type=style&index=0&id=6e6eae5f&lang=scss"

import exportComponent from "E:\\DevWorkspaces\\WorkSpaces\\sts3.9.9\\ZhaoTong\\laborEmpWeb\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__